import { render } from "./field_type.vue?vue&type=template&id=3265dcd8"
import script from "./field_type.vue?vue&type=script&lang=js"
export * from "./field_type.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__